/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StreamDeletionRequestCalloutContainer_viewer = {
    readonly scheduledDeletionDate: string | null;
    readonly " $refType": "StreamDeletionRequestCalloutContainer_viewer";
};
export type StreamDeletionRequestCalloutContainer_viewer$data = StreamDeletionRequestCalloutContainer_viewer;
export type StreamDeletionRequestCalloutContainer_viewer$key = {
    readonly " $data"?: StreamDeletionRequestCalloutContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"StreamDeletionRequestCalloutContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamDeletionRequestCalloutContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scheduledDeletionDate",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '30e6a790ebb6a322efb594b8a18811f4';
export default node;
